import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-filter-favourite-action',
  templateUrl: './filter-favourite-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FilterFavouriteActionComponent {
  @Input() isFavourite: boolean = false;
  @Output() toggled = new EventEmitter<void>();

  onToggle(): void {
    this.toggled.emit();
  }
}
